<template>
	<div class="hero-frame"
		:class="[{ 'games-mode': mode == 'games', 'dashboard-mode': mode == 'dashboard' }, currentHero.item.style_tag]">
		<div class="hero-area" :class="[currentHero.item.style_tag]" :style="{
			backgroundImage: `url(${appMode ? 'https://api.dev.indigomental.com' : ''
				}${currentFace ? currentHero.item.additional_file : currentHero.file
				} )`,
		}">
			<div v-if="currentCap" class="cap" :class="[currentCap.item.style_tag]" :style="{
				backgroundImage: `url(${appMode ? 'https://api.dev.indigomental.com' : ''
					}${currentCap.file})`,
			}"></div>

			<div v-if="currentFace" class="face" :class="[currentFace.item.style_tag]" :style="{
				backgroundImage: `url(${appMode ? 'https://api.dev.indigomental.com' : ''
					}${currentFace.item.additional_file})`,
			}"></div>

			<div v-if="currentAnimal" class="animal" :class="[currentAnimal.item.style_tag]" :style="{
				backgroundImage: `url(${appMode ? 'https://api.dev.indigomental.com' : ''
					}${currentAnimal.item.additional_file})`,
			}"></div>

			<div v-if="currentDevice" class="device" :class="[currentDevice.item.style_tag]" :style="{
				backgroundImage: `url(${appMode ? 'https://api.dev.indigomental.com' : ''
					}${currentDevice.file})`,
			}"></div>
		</div>

		<div v-if="currentTransport" class="transport" :class="[currentTransport.item.style_tag]" :style="{
			backgroundImage: `url(${appMode ? 'https://api.dev.indigomental.com' : ''
				}${currentTransport.file})`,
		}"></div>
	</div>
</template>

<script>
export default {
	name: 'custom-character',
	props: ['purchasedItemsList', 'mode'],
	data: () => ({
		appMode: false,
	}),
	computed: {
		currentHero() {
			return this.purchasedItemsList.find(
				el => el.item?.category == 'HERO' && el.is_activated == true
			)
		},
		currentCap() {
			return this.purchasedItemsList.find(
				el => el.item?.category == 'CAP' && el.is_activated == true
			)
		},
		currentFace() {
			return this.purchasedItemsList.find(
				el => el.item?.category == 'FACE' && el.is_activated == true
			)
		},
		currentTransport() {
			return this.purchasedItemsList.find(
				el => el.item?.category == 'TRANSPORTS' && el.is_activated == true
			)
		},
		currentAnimal() {
			return this.purchasedItemsList.find(
				el => el.item?.category == 'ANIMALS' && el.is_activated == true
			)
		},
		currentDevice() {
			return this.purchasedItemsList.find(
				el => el.item?.category == 'DEVICES' && el.is_activated == true
			)
		},
	},
}
</script>

<style lang="scss" scoped>
//Hero styles

.hero-frame {
	position: relative;

	width: 300px;
	height: 400px;

	margin-bottom: 50px;
	margin-left: 5%;

	// aspect-ratio: 300 / 400;

	@media (max-width: 767px) {
		transform: scale(0.9) translateY(-50px);

		transform-origin: bottom left;

		margin-left: 0;

		margin-top: 10px;
		margin-bottom: 10px;
	}

	@media (max-width: 400px) {
		transform: scale(0.8) translateY(-50px);
	}

	@media (max-width: 330px) {
		transform: scale(0.7) translateY(-50px);
	}

	&.dashboard-mode {
		position: absolute;

		left: 50%;
		top: 50%;

		transform: scale(0.50) translate(-65%, -50%);
		transform-origin: top left;

		margin-bottom: 0;
		margin-left: 0;

		@media (max-width: 767px) {
			transform: scale(0.6) translate(-60%, -45%);
		}
	}

	&.games-mode {
		// margin-right: 0;
		// margin-left: 0;

		left: 0;
		top: 0;

		transform: scale(0.6) translateY(-50px);
		transform-origin: top left;
	}

	& .skateboard {
		position: absolute;

		top: 45%;
		left: 13%;

		width: 300px;
		height: 300px;

		z-index: 0;

		// @media (max-width: 767px) {
		// 	top: 60%;
		// }
	}

	& .hover-board {
		position: absolute;

		top: 45%;
		left: 15%;

		width: 300px;
		height: 300px;

		z-index: 0;

		// @media (max-width: 767px) {
		// 	top: 60%;
		// }
	}
}

.hero-frame.hero-indigo {
	& .skateboard {
		top: 40%;
	}

	& .hover-board {
		top: 40%;
	}
}

.hero-frame.hero-sky {
	& .skateboard {
		top: 39%;
	}

	& .hover-board {
		top: 39%;
	}
}

.hero-frame.hero-devil {
	& .skateboard {
		top: 42%;
	}

	& .hover-board {
		top: 42%;
	}
}

.hero-frame.hero-pink {
	& .skateboard {
		left: 11%;
	}

	& .hover-board {
		left: 11%;
	}
}

.hero-area {
	position: absolute;
	width: 300px;
	height: 400px;

	// aspect-ratio: 300 / 400;

	// margin-right: auto;
	// margin-left: auto;

	left: 14%;
	// transform: translate(-50%, 0);

	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 2;

	// @media (max-width: 767px) {
	// 	// width: 100%;
	// 	// height: 400px;

	// 	margin-top: 50px;
	// }
}



.transport {
	position: absolute;

	width: 200px;
	height: 200px;

	top: -5%;
	left: 18%;

	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 5;
}

//Caps styles
.cap {
	position: absolute;

	width: 200px;
	height: 200px;

	top: -5%;
	left: 18%;

	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 5;
}

.device {
	position: absolute;

	width: 200px;
	height: 200px;

	top: -5%;
	left: 18%;

	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 6;
}

.hero-area.hero-indigo {
	& .cap.antler {
		top: -4%;
		left: 15%;

		transform: rotate(5deg);
	}

	& .cap.santa-hat {
		top: 4%;
		left: 28%;

		width: 170px;
		height: 170px;

		transform: rotate(-2deg);
	}

	& .cap.santa-blue-hat {
		top: 6%;
		left: 27%;

		width: 130px;
		height: 130px;

		transform: rotate(1deg);
	}

	& .cap.sombrero-hat {
		top: -6%;
		left: 15%;

		width: 220px;
		height: 220px;

		transform: rotate(3deg);
	}

	& .cap.elf-hat {
		top: 3%;
		left: 30%;

		width: 125px;
		height: 125px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: 6%;
		left: 27%;

		width: 140px;
		height: 140px;

		// transform: rotate(2deg);
	}

	& .cap.halloween-hat {
		top: -5%;
	}

	//Transport

	& .skateboard {
		position: absolute;

		top: 46%;
		left: 0%;

		width: 300px;
		height: 300px;

		z-index: 0;
	}

	& .hover-board {
		position: absolute;

		top: 46%;
		left: 0%;

		width: 300px;
		height: 300px;

		z-index: 0;
	}

	//Devices

	& .device.ice-cream {
		top: 41%;
		left: 75%;

		width: 80px;
		height: 80px;
	}

	& .device.Watch {
		top: 49%;
		left: 78%;

		width: 22px;
		height: 22px;

		transform: rotate(20deg);
	}

	& .device.cotton-candy {
		top: 22%;
		left: 63%;

		width: 180px;
		height: 180px;

		transform: rotate(4deg);
	}

	& .device.magic-wand {
		top: 17%;
		left: 59%;

		width: 200px;
		height: 200px;

		transform: rotate(70deg);
	}

	& .device.ballons {
		top: -1%;
		left: -42%;

		width: 300px;
		height: 300px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-sea {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -15%;
		left: 11%;

		transform: rotate(1deg);
	}

	& .cap.santa-hat {
		top: -12%;
		left: 21%;

		width: 240px;
		height: 240px;

		transform: rotate(-2deg);
	}

	& .cap.santa-blue-hat {
		top: -8%;
		left: 16%;

		width: 180px;
		height: 180px;

		transform: rotate(-3deg);
	}

	& .cap.sombrero-hat {
		top: -22%;
		left: 5%;

		width: 280px;
		height: 280px;

		transform: rotate(1deg);
	}

	& .cap.elf-hat {
		top: -10%;
		left: 16%;

		width: 200px;
		height: 160px;

		transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -17%;
		left: 8%;

		width: 250px;
		height: 250px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: -10%;
		left: 14%;

		width: 220px;
		height: 220px;
	}

	& .cap.halloween-hat {
		top: -16%;
		left: 10%;

		width: 240px;
		height: 240px;
	}

	//Devices

	& .device.ice-cream {
		top: 58%;
		left: 78%;

		width: 80px;
		height: 80px;

		transform: rotate(50deg);
	}

	& .device.Watch {
		top: 59%;
		left: 78%;

		width: 42px;
		height: 42px;

		transform: rotate(245deg);
	}

	& .device.cotton-candy {
		top: 48%;
		left: 73%;

		width: 140px;
		height: 140px;

		transform: rotate(50deg);
	}

	& .device.magic-wand {
		top: 47%;
		left: 78%;

		width: 140px;
		height: 140px;

		transform: rotate(120deg);
	}

	& .device.ballons {
		top: -18%;
		left: -66%;

		width: 420px;
		height: 420px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-devil {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -5%;
		left: 11%;

		transform: rotate(2deg);
	}

	& .cap.santa-hat {
		top: 4%;
		left: 25%;

		width: 180px;
		height: 180px;

		transform: rotate(-7deg);
	}

	& .cap.santa-blue-hat {
		top: 5%;
		left: 25%;

		width: 140px;
		height: 140px;

		transform: rotate(1deg);
	}

	& .cap.sombrero-hat {
		top: -1%;
		left: 17%;

		width: 200px;
		height: 200px;

		transform: rotate(-2deg);
	}

	& .cap.elf-hat {
		top: 2%;
		left: 28%;

		width: 135px;
		height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -2%;
		// left: 28%;

		// width: 135px;
		// height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: 10%;
		left: 26%;

		width: 140px;
		height: 140px;

		// transform: rotate(2deg);
	}

	& .cap.halloween-hat {
		top: -1%;
	}

	//Devices

	& .device.ice-cream {
		top: 56%;
		left: 73%;

		width: 80px;
		height: 80px;

		transform: rotate(30deg);
	}

	& .device.Watch {
		top: 57%;
		left: 75%;

		width: 38px;
		height: 38px;

		transform: rotate(205deg);
	}

	& .device.cotton-candy {
		top: 47%;
		left: 71%;

		width: 140px;
		height: 140px;

		transform: rotate(50deg);
	}

	& .device.magic-wand {
		top: 47%;
		left: 70%;

		width: 140px;
		height: 140px;

		transform: rotate(120deg);
	}

	& .device.ballons {
		top: -15%;
		left: -54%;

		width: 400px;
		height: 400px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-sky {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -5%;
		left: 11%;

		transform: rotate(2deg);
	}

	& .cap.santa-hat {
		top: 4%;
		left: 25%;

		width: 180px;
		height: 180px;

		transform: rotate(-7deg);
	}

	& .cap.santa-blue-hat {
		top: 5%;
		left: 25%;

		width: 140px;
		height: 140px;

		transform: rotate(1deg);
	}

	& .cap.sombrero-hat {
		top: -1%;
		left: 17%;

		width: 200px;
		height: 200px;

		transform: rotate(-2deg);
	}

	& .cap.elf-hat {
		top: 2%;
		left: 28%;

		width: 135px;
		height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -2%;
		// left: 28%;

		// width: 135px;
		// height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: 0;
		// left: 19%;

		// width: 190px;
		// height: 190px;

		// transform: rotate(2deg);
	}

	//Devices

	& .device.ice-cream {
		top: 37%;
		left: 74%;

		width: 100px;
		height: 100px;

		transform: rotate(-10deg);
	}

	& .device.Watch {
		top: 48%;
		left: 73%;

		width: 54px;
		height: 54px;

		transform: rotate(-230deg);
	}

	& .device.cotton-candy {
		top: 24%;
		left: 66%;

		width: 160px;
		height: 160px;

		transform: rotate(0deg);
	}

	& .device.magic-wand {
		top: 23%;
		left: 65%;

		width: 160px;
		height: 160px;

		transform: rotate(60deg);
	}

	& .device.ballons {
		top: -15%;
		left: -53%;

		width: 350px;
		height: 350px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-green {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -6%;
		left: 11%;

		transform: rotate(2deg);
	}

	& .cap.santa-hat {
		top: 4%;
		left: 25%;

		width: 180px;
		height: 180px;

		transform: rotate(-7deg);
	}

	& .cap.santa-blue-hat {
		top: 5%;
		left: 25%;

		width: 140px;
		height: 140px;

		transform: rotate(1deg);
	}

	& .cap.sombrero-hat {
		top: -1%;
		left: 17%;

		width: 200px;
		height: 200px;

		transform: rotate(-2deg);
	}

	& .cap.elf-hat {
		top: 2%;
		left: 28%;

		width: 135px;
		height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -2%;
		left: 20%;

		width: 190px;
		height: 190px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: 8%;
		left: 27%;

		width: 140px;
		height: 140px;

		// transform: rotate(2deg);
	}

	& .cap.halloween-hat {
		top: -5%;
	}

	//Devices

	& .device.ice-cream {
		top: 58%;
		left: 72%;

		width: 100px;
		height: 100px;

		transform: rotate(70deg);
	}

	& .device.Watch {
		top: 57%;
		left: 76%;

		width: 42px;
		height: 42px;

		transform: rotate(225deg);
	}

	& .device.cotton-candy {
		top: 54%;
		left: 72%;

		width: 140px;
		height: 140px;

		transform: rotate(80deg);
	}

	& .device.magic-wand {
		top: 53%;
		left: 74%;

		width: 140px;
		height: 140px;

		transform: rotate(140deg);
	}

	& .device.ballons {
		top: 6%;
		left: -40%;

		width: 300px;
		height: 300px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-orange {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -16%;
		left: 11%;

		transform: rotate(1deg);
	}

	& .cap.santa-hat {
		top: -4%;
		left: 25%;

		width: 180px;
		height: 180px;

		transform: rotate(-7deg);
	}

	& .cap.santa-blue-hat {
		top: -5%;
		left: 25%;

		width: 140px;
		height: 140px;

		transform: rotate(1deg);
	}

	& .cap.sombrero-hat {
		top: -10%;
		left: 17%;

		width: 200px;
		height: 200px;

		transform: rotate(-2deg);
	}

	& .cap.elf-hat {
		top: -7%;
		left: 28%;

		width: 135px;
		height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -12%;
		left: 19%;

		width: 190px;
		height: 190px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: -1%;
		left: 27%;

		width: 140px;
		height: 140px;

		// transform: rotate(2deg);
	}

	& .cap.halloween-hat {
		top: -14%;
	}

	//Devices

	& .device.ice-cream {
		top: 53%;
		left: 77%;

		width: 80px;
		height: 80px;

		transform: rotate(30deg);
	}

	& .device.Watch {
		top: 53%;
		left: 73%;

		width: 48px;
		height: 48px;

		transform: rotate(215deg);
	}

	& .device.cotton-candy {
		top: 45%;
		left: 73%;

		width: 140px;
		height: 140px;

		transform: rotate(50deg);
	}

	& .device.magic-wand {
		top: 43%;
		left: 73%;

		width: 140px;
		height: 140px;

		transform: rotate(110deg);
	}

	& .device.ballons {
		top: -14%;
		left: -55%;

		width: 380px;
		height: 380px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-wings {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -5%;
		left: 11%;

		transform: rotate(2deg);
	}

	& .cap.santa-hat {
		top: 6%;
		left: 25%;

		width: 180px;
		height: 180px;

		transform: rotate(-7deg);
	}

	& .cap.santa-blue-hat {
		top: 9%;
		left: 27%;

		width: 120px;
		height: 120px;

		transform: rotate(1deg);
	}

	& .cap.sombrero-hat {
		top: -1%;
		left: 17%;

		width: 200px;
		height: 200px;

		transform: rotate(-2deg);
	}

	& .cap.elf-hat {
		top: 4%;
		left: 28%;

		width: 135px;
		height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -2%;
		// left: 28%;

		// width: 135px;
		// height: 135px;

		// transform: rotate(2deg);
	}

	& .cap.black-hat {
		top: 4%;
		left: 21%;

		width: 180px;
		height: 180px;

		// transform: rotate(2deg);
	}

	& .cap.halloween-hat {
		top: -4%;
	}

	//Devices

	& .device.ice-cream {
		top: 30%;
		left: 75%;

		width: 80px;
		height: 80px;

		transform: rotate(-30deg);
	}

	& .device.Watch {
		top: 41%;
		left: 71%;

		width: 42px;
		height: 42px;

		transform: rotate(-250deg);
	}

	& .device.cotton-candy {
		top: 8%;
		left: 48%;

		width: 180px;
		height: 180px;

		transform: rotate(-55deg);
	}

	& .device.magic-wand {
		top: 9%;
		left: 47%;

		width: 180px;
		height: 180px;

		transform: rotate(10deg);
	}

	& .device.ballons {
		top: -15%;
		left: -44%;

		width: 300px;
		height: 300px;

		// transform: rotate(70deg);
	}
}

.hero-area.hero-pink {
	& .cap.antler {
		width: 220px;
		height: 200px;

		top: -12%;
		left: 12%;

		transform: rotate(6deg);
	}

	& .cap.santa-hat {
		top: 1%;
		left: 27%;

		width: 170px;
		height: 170px;

		transform: rotate(1deg);
	}

	& .cap.santa-blue-hat {
		top: 2%;
		left: 28%;

		width: 120px;
		height: 120px;

		transform: rotate(5deg);
	}

	& .cap.sombrero-hat {
		top: -8%;
		left: 19%;

		width: 200px;
		height: 200px;

		transform: rotate(6deg);
	}

	& .cap.elf-hat {
		top: 2%;
		left: 31%;

		width: 110px;
		height: 110px;

		// transform: rotate(2deg);
	}

	& .cap.winter-hat {
		top: -2%;
		left: 26%;

		width: 160px;
		height: 160px;

		transform: rotate(6deg);
	}

	& .cap.black-hat {
		top: 2%;
		left: 26%;

		width: 140px;
		height: 140px;

		transform: rotate(2deg);
	}

	& .cap.halloween-hat {
		top: -10%;

		transform: rotate(2deg);
	}

	//Devices

	& .device.ice-cream {
		top: 42%;
		left: -3%;

		width: 100px;
		height: 100px;

		transform: rotate(-95deg);
	}

	& .device.Watch {
		top: 51%;
		left: 57%;

		width: 60px;
		height: 60px;

		transform: rotate(-95deg);
	}

	& .device.cotton-candy {
		top: 35%;
		left: -22%;

		width: 160px;
		height: 160px;

		transform: rotate(-95deg);
	}

	& .device.magic-wand {
		top: 35%;
		left: -25%;

		width: 160px;
		height: 160px;

		transform: rotate(-30deg);
	}

	& .device.ballons {
		top: -1%;
		left: -40%;

		width: 300px;
		height: 300px;

		// transform: rotate(70deg);
	}
}

//Faces styles

.face {
	position: absolute;

	width: 150px;
	height: 150px;

	top: 28%;
	left: 25%;

	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 3;
}

// .hero-area.hero-indigo {
// 	& .face {
// 		top: -4%;
// 		left: 15%;

// 		transform: rotate(5deg);
// 	}
// }

.hero-area.hero-sea {
	& .face {
		width: 170px;
		height: 170px;

		top: 25%;
		left: 22%;
	}
}

.hero-area.hero-devil {
	& .face {
		// width: 220px;
		// height: 200px;

		// top: -5%;
		// left: 11%;

		// transform: rotate(2deg);
	}
}

.hero-area.hero-sky {
	& .face {
		// 	width: 220px;
		// 	height: 200px;

		top: 30%;
		// left: 11%;

		// 	transform: rotate(2deg);
	}
}

.hero-area.hero-green {
	& .face {
		// width: 220px;
		// height: 200px;

		top: 32%;
		// left: 11%;

		// transform: rotate(2deg);
	}
}

.hero-area.hero-orange {
	& .face {
		width: 130px;
		height: 120px;

		top: 23%;
		left: 29%;
	}
}

.hero-area.hero-wings {
	& .face {
		width: 120px;
		height: 120px;

		top: 31%;
		left: 30%;

		// transform: rotate(2deg);
	}
}

.hero-area.hero-pink {
	& .face {
		width: 120px;
		height: 100px;

		top: 25%;
		left: 29%;
	}
}

.hero-area .dog {
	position: absolute;

	width: 140px;
	height: 140px;

	// top: 48%;
	// left: 60%;

	top: 50%;
	left: -4%;

	transform: scaleX(-1);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 7;
}

.hero-area .cat {
	position: absolute;

	width: 110px;
	height: 110px;

	top: 54%;
	left: -5%;

	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	z-index: 7;
}
</style>
